import { render, staticRenderFns } from "./ProductReviews.vue?vue&type=template&id=91a363e4&scoped=true"
import script from "./ProductReviews.vue?vue&type=script&lang=js"
export * from "./ProductReviews.vue?vue&type=script&lang=js"
import style0 from "./ProductReviews.vue?vue&type=style&index=0&id=91a363e4&prod&scoped=true&lang=css"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "./ProductReviews.vue?vue&type=style&index=2&id=91a363e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91a363e4",
  null
  
)

export default component.exports